module.exports = __webpack_public_path__ + "ODIQ-home-bg2.a7d8d08687711ee5abc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ODIQ-home-bg2.jpg
// module id = 1706
// module chunks = 0